import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';
import {TableauReportsService} from "../../services/tableau-reports/tableau-reports.service";
import {forkJoin} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {AlertService} from "../../services/alert/alert.service";
import {TABLEAU_DASHBOARDS} from "../../shared/common-components/AppConstants";
import {LoadingService} from "../../services/loading/loading.service";

@Component({
    selector: 'app-frt-tableau-dashboards',
    imports: [],
    templateUrl: './frt-tableau-dashboards.component.html',
    styleUrl: './frt-tableau-dashboards.component.css',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FrtTableauDashboardsComponent implements OnInit {
  showExport = false;
  excelSheetNames = [] as string[];
  dashboardName;
  accessID;
  viz: any

  constructor(private tableauReportsService: TableauReportsService, private route: ActivatedRoute,
              private alertService: AlertService, private loader: LoadingService
  ) { }

  ngOnInit() {
    this.loader.show();
    this.route.paramMap.subscribe(params => {
      if (params.has('dashboardName')) {
        this.dashboardName = params.get('dashboardName');
        this.tableauReportsService.getTableauReports(this.dashboardName, 'FRT').subscribe((response1: string[]) => {
          this.initializeViz(response1);
          this.loader.hide();
        }, error => {
          this.loader.hide();
          this.alertService.error('Error while fetching the dashboard data.');
        })
      }
    });
  }

  initializeViz(url: string[]) {
    document.getElementById("tableauViz").shadowRoot.getElementById("tableauViz").removeAttribute("sandbox");
    this.viz = document.getElementById("tableauViz");
    this.viz.width = 1000;
    this.viz.height = 827;
    this.viz.hideTabs = true;
    this.viz.hideToolbar = true;
    const onFirstInteractive = () => {

      this.showExport = true;
      const activeSheet = this.viz.workbook.activeSheet;
      const worksheets = activeSheet.worksheets;
      const workbook = activeSheet.workbook;
     // this.excelSheetNames = this.viz.workbook.name;
     this.excelSheetNames = worksheets
     .map(sheet => sheet.name)
     .filter(name => name.includes("Raw Data"));

      // document.getElementById("tableauViz").shadowRoot.getElementById("tableauViz").setAttribute("sandbox", "allow-same-origin allow-scripts allow-downloads");
      document.getElementById("tableauViz").shadowRoot.getElementById("tableauViz").setAttribute("sandbox", "allow-downloads");
    };

    this.viz.addEventListener("firstinteractive", onFirstInteractive);
    this.viz.src = url[1];
    this.viz.token = url[0];
    this.accessID = url[2];
    document.getElementById("accessIdParm").setAttribute("value",this.accessID);
  }

   // Downloads the crosstab data in an Excel file
   async exportToExcel() {
    /*
    if (!this.excelSheetNames?.length) {
      return window.alert('No Raw data found to export.');
    }
    this.excelSheetNames.forEach(name => this.viz?.exportCrosstabAsync(name, "xlsx"));
    */
    const activeSheet = this.viz.workbook.activeSheet;
    const worksheets = activeSheet.worksheets;
    // use the first worksheet
    const selectedWorksheetForExport = worksheets.find(x => x?.name?.indexOf("Raw Data") > -1);
    // include all columns in the summary data
    const columns =
        await selectedWorksheetForExport.getSummaryColumnsInfoAsync();
    const columnsToInclude = Array.from(
        columns,
        (column:any) => column.fieldId
    );
    const ignoreAliases = false;
    const exportDataOptions = { ignoreAliases, columnsToInclude };
    console.log("Export Data:");
    try {
        await this.viz
            .exportDataAsync(selectedWorksheetForExport.name, exportDataOptions)
            .then(() => {
                console.log(
                    `${selectedWorksheetForExport.name}:`,
                    exportDataOptions
                );
            });
    } catch {
        console.error("Cannot downlod");
    }
  }

  getDashboardTitle(name: string): string {
   return TABLEAU_DASHBOARDS[name];
  }

  exportToXlsx() {
    if (!this.excelSheetNames?.length) {
      return window.alert('No Raw data found to export.');
    }
    this.excelSheetNames.forEach(name => this.viz?.exportCrosstabAsync(name, "xlsx"));
  }
}
